import { render, staticRenderFns } from "./dashboardFaslodex.vue?vue&type=template&id=1fadf8a3&"
import script from "./dashboardFaslodex.vue?vue&type=script&lang=js&"
export * from "./dashboardFaslodex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports